import { Component, EventEmitter, Input, Output } from '@angular/core';

type TagCardImgShape = 'round' | 'squared';

@Component({
  selector: 'getm-tag-card-img',
  templateUrl: './tag-card-img.component.html',
  styleUrls: ['./tag-card-img.component.scss'],
})
export class TagCardImgComponent {

  @Input() icon: string = null;
  @Input() iconColor: string = 'contrast';
  @Input() slotIcon: 'left' | 'right' = 'left';
  @Input() label: string = null;
  @Input() shape: TagCardImgShape = 'squared';
  @Input() color: string = 'primary';
  @Input() size: 'small' | 'medium' | 'large' | 'x-large' = 'medium';
  @Input() fill: 'solid' | 'outline' = 'solid';

  @Output() tagClick = new EventEmitter<void>();

  public onTagClick = (): void => this.tagClick.emit();
}
